// AB#17142: pure response-error helpers (no React/toast imports) so node can test them directly.
export const FORBIDDEN_ERROR = "You do not have permission to perform this action. If your access changed recently, sign out and back in.";
export const SAVE_GENERIC_ERROR = "Something went wrong while saving. Please try again.";
export const SESSION_EXPIRED_ERROR = "Your session has expired. Please sign in again.";

// An empty, non-JSON or already-read body (e.g. a bare 403) returns null instead of throwing "Unexpected end of JSON input".
export const readJsonSafe = async (response) => {
  try {
    const text = await response.text();
    return text ? JSON.parse(text) : null;
  } catch (e) {
    return null;
  }
};

// Server rules errors arrive as [{ exceptionMessage }]; otherwise fall back by status.
export const getResponseErrorMessage = (response, data, fallback = SAVE_GENERIC_ERROR) => {
  const first = Array.isArray(data) ? data[0] : data;
  const serverMessage = first?.exceptionMessage || first?.message;
  if (serverMessage) return serverMessage;
  if (response?.status === 401) return SESSION_EXPIRED_ERROR;
  if (response?.status === 403) return FORBIDDEN_ERROR;
  return fallback;
};
